import ChatIcon from '@mui/icons-material/Chat';
import HubIcon from '@mui/icons-material/Hub';
import EditNoteIcon from '@mui/icons-material/EditNote';
import PeopleIcon from '@mui/icons-material/People';
import PermMediaIcon from '@mui/icons-material/PermMedia';
import PersonIcon from '@mui/icons-material/Person';
import NotificationsIcon from '@mui/icons-material/Notifications';
import PsychologyIcon from '@mui/icons-material/Psychology';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import StorageIcon from '@mui/icons-material/Storage';
import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../redux/store';

export interface NavItem {
    text: string;
    icon: React.ReactNode;
    route: string;
}

export const navItems: NavItem[] = [
    { text: 'Collections', icon: <StorageIcon />, route: '/collections' },
    { text: 'Profile', icon: <PersonIcon />, route: '/profile' },
    { text: 'Memory', icon: <PsychologyIcon />, route: '/memory' },
    { text: 'Users', icon: <PeopleIcon />, route: '/users' },
    { text: 'Messages', icon: <ChatIcon />, route: '/messages' },
    { text: 'Uploads', icon: <PermMediaIcon />, route: '/uploads' },
    { text: 'Prompts', icon: <EditNoteIcon />, route: '/prompts' },
    { text: 'Reminders', icon: <NotificationsIcon />, route: '/reminders' },
    { text: 'Quality', icon: <QueryStatsIcon />, route: '/quality' },
    { text: 'Vector Space', icon: <HubIcon />, route: '/vector-space' },
];

/** The nav route a path belongs to; sub-pages such as /prompts/:id/edit keep their section. */
export const activeNavRoute = (pathname: string): string | false =>
    navItems.find(
        (i) => pathname === i.route || pathname.startsWith(`${i.route}/`)
    )?.route ?? false;

// Badge counts shown next to nav entries, keyed by route.
export const useNavCounts = (): Record<string, number | undefined> => {
    const vectors = useSelector((state: RootState) =>
        state.collections.collections.reduce((sum, c) => sum + c.count, 0)
    );
    const users = useSelector((state: RootState) => state.users.users.length);

    return {
        '/collections': vectors,
        '/users': users,
    };
};
